import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Map, ArrowRight } from "lucide-react";

export default function BecomePartner() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-stone-50">

      {/* Hero */}
      <section className="px-6 py-16 md:py-24">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-3 py-1 bg-orange-100 text-orange-700 text-xs font-semibold rounded-full uppercase tracking-wider mb-4">
            Programme partenaire · 100% B2B
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-stone-800 leading-tight mb-6">
            Recommandez Blackout Games,<br />
            <span className="text-orange-600">touchez 10% sur chaque première vente.</span>
          </h1>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto mb-8">
            Vous gérez une escape room ou une boutique de jeux ? Recommandez Blackout Games - escape game digital pour <strong className="text-stone-800">team buildings et séminaires d'entreprise</strong> - à vos clients pros, et touchez une commission sur chaque première vente générée.
          </p>
          <a
            href="mailto:contact@blackout-games.fr?subject=Demande%20programme%20partenaire&body=Bonjour%20William%2C%0A%0AJe%20souhaiterais%20rejoindre%20votre%20programme%20partenaire.%0A%0AVoici%20quelques%20infos%20sur%20moi%20%3A%0A-%20Nom%20de%20la%20structure%20%3A%20%0A-%20Type%20(escape%20room%20%2F%20boutique%20jeux%20%2F%20autre)%20%3A%20%0A-%20Site%20web%20%2F%20Instagram%20%3A%20%0A-%20Ville%20%3A%20%0A%0AMerci%20%3A)"
            className="inline-block px-8 py-4 bg-orange-600 hover:bg-orange-500 text-white rounded-xl text-lg font-semibold shadow-lg shadow-orange-200 transition-all hover:shadow-xl hover:-translate-y-0.5"
          >
            Nous contacter
          </a>
          <p className="text-xs text-stone-500 mt-3">
            ou écrivez-nous à <a href="mailto:contact@blackout-games.fr" className="underline hover:text-orange-600">contact@blackout-games.fr</a>
          </p>
        </div>
      </section>

      {/* Comment ça marche */}
      <section className="px-6 py-16 bg-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold text-stone-800 text-center mb-12">
            Comment ça marche
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <Step
              number="1"
              title="On fait connaissance"
              description="Vous nous contactez, on échange brièvement pour s'assurer que le programme vous correspond. Si oui, on vous crée un compte avec votre code promo personnel."
            />
            <Step
              number="2"
              title="Vous diffusez votre code"
              description="Vous distribuez votre code à vos clients : flyers en boutique, dans vos box, par email, sur vos réseaux. Le canal qui vous convient."
            />
            <Step
              number="3"
              title="Vous touchez 10%"
              description="Chaque fois qu'un client utilise votre code, il bénéficie de 10% de réduction et vous touchez 10% du montant payé. Suivi en temps réel sur votre espace partenaire."
            />
          </div>
        </div>
      </section>

      {/* Pour qui */}
      <section className="px-6 py-16">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold text-stone-800 text-center mb-4">
            Pour qui ?
          </h2>
          <p className="text-center text-stone-600 mb-12 max-w-2xl mx-auto">
            Le programme s'adresse aux structures dont la clientèle inclut des <strong className="text-stone-800">entreprises, RH et office managers</strong> qui cherchent des activités de cohésion d'équipe.
          </p>
          <div className="grid md:grid-cols-2 gap-6">
            <Audience
              icon="🔐"
              title="Escape rooms physiques"
              description="Vos clients pros (entreprises, séminaires, EVJF, EVG) cherchent parfois une expérience à distance pour leurs équipes en télétravail. Recommandez-leur Blackout Games sans concurrencer votre activité présentielle."
            />
            <Audience
              icon="🎲"
              title="Boutiques de jeux"
              description="Vos clients réservent vos jeux pour des soirées entre amis ou en famille. Mais certains gèrent aussi des équipes en entreprise et cherchent des outils de team building digital. Voilà à qui ils peuvent s'adresser."
            />
          </div>
        </div>
      </section>

      {/* Pourquoi nous rejoindre */}
      <section className="px-6 py-16 bg-stone-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-stone-800 text-center mb-12">
            Pourquoi nous rejoindre
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <Benefit
              title="10% en cash"
              description="Pas de bons d'achat, pas de système de points. Vous touchez 10% du montant payé sur chaque première vente, par virement."
            />
            <Benefit
              title="Pas de quota, pas d'engagement"
              description="Vous diffusez quand vous voulez, comme vous voulez. Aucun objectif de vente imposé."
            />
            <Benefit
              title="Suivi transparent en temps réel"
              description="Votre espace partenaire vous montre vos ventes, vos commissions et leur statut de versement. Vous savez toujours où vous en êtes."
            />
            <Benefit
              title="Aucune concurrence avec votre activité"
              description="Nous ne vendons qu'aux entreprises (séminaires, team buildings, onboardings). Vos clients particuliers continuent à venir chez vous comme avant, Blackout Games s'adresse à un autre marché."
            />
          </div>
        </div>
      </section>

      {/* Notre vision (lien roadmap) */}
<section className="px-6 py-12 bg-white border-y border-stone-100">
  <div className="max-w-4xl mx-auto">
    <Link
      to="/roadmap"
      className="group flex flex-col md:flex-row items-center gap-6 p-6 rounded-2xl bg-gradient-to-br from-indigo-50 via-white to-orange-50 border border-stone-200 hover:border-indigo-200 hover:shadow-md transition"
    >
      <div className="flex-shrink-0 w-14 h-14 rounded-2xl bg-indigo-600 flex items-center justify-center text-white shadow-md">
        <Map className="h-6 w-6" />
      </div>
      <div className="flex-1 text-center md:text-left">
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-indigo-600 mb-1">
          Vous misez sur un projet qui avance
        </p>
        <h3 className="text-lg font-bold text-stone-800 mb-1">
          Découvrez notre roadmap publique
        </h3>
        <p className="text-sm text-stone-600 leading-relaxed">
          On ne fait pas que du marketing. Voyez ce qui a été livré, ce qui se construit et ce qui arrive ensuite.
        </p>
      </div>
      <div className="flex-shrink-0 inline-flex items-center gap-2 text-sm font-semibold text-indigo-600 group-hover:text-indigo-500 transition whitespace-nowrap">
        Voir la trajectoire
        <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
      </div>
    </Link>
  </div>
</section>

      {/* CTA final */}
      <section className="px-6 py-16">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-stone-800 mb-4">
            Envie de rejoindre l'aventure ?
          </h2>
          <p className="text-stone-600 mb-8">
            Écrivez-nous en quelques lignes. Le programme démarre dès que c'est validé.
          </p>
          <a
            href="mailto:contact@blackout-games.fr?subject=Demande%20programme%20partenaire&body=Bonjour%20William%2C%0A%0AJe%20souhaiterais%20rejoindre%20votre%20programme%20partenaire.%0A%0AVoici%20quelques%20infos%20sur%20moi%20%3A%0A-%20Nom%20de%20la%20structure%20%3A%20%0A-%20Type%20(escape%20room%20%2F%20boutique%20jeux%20%2F%20autre)%20%3A%20%0A-%20Site%20web%20%2F%20Instagram%20%3A%20%0A-%20Ville%20%3A%20%0A%0AMerci%20%3A)"
            className="inline-block px-8 py-4 bg-orange-600 hover:bg-orange-500 text-white rounded-xl text-lg font-semibold shadow-lg shadow-orange-200 transition-all hover:shadow-xl hover:-translate-y-0.5"
          >
            Nous contacter
          </a>
        </div>
      </section>

      {/* Bandeau "déjà partenaire" */}
      <section className="px-6 py-10 bg-stone-800 text-stone-100">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-sm text-stone-400 mb-2">Déjà partenaire ?</p>
          <Link
            to="/affilie/login"
            className="inline-block text-lg font-semibold text-amber-300 hover:text-amber-200 transition"
          >
            Accéder à mon espace partenaire →
          </Link>
        </div>
      </section>
    </div>
  );
}

function Step({ number, title, description }) {
  return (
    <div className="text-center">
      <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-orange-100 flex items-center justify-center text-2xl font-bold text-orange-600">
        {number}
      </div>
      <h3 className="text-lg font-semibold text-stone-800 mb-2">{title}</h3>
      <p className="text-sm text-stone-600 leading-relaxed">{description}</p>
    </div>
  );
}

function Audience({ icon, title, description }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-stone-200 p-6">
      <div className="text-4xl mb-3">{icon}</div>
      <h3 className="text-lg font-semibold text-stone-800 mb-2">{title}</h3>
      <p className="text-sm text-stone-600 leading-relaxed">{description}</p>
    </div>
  );
}

function Benefit({ title, description }) {
  return (
    <div>
      <div className="flex items-start gap-3">
        <span className="flex-shrink-0 w-6 h-6 rounded-full bg-orange-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          ✓
        </span>
        <div>
          <h3 className="text-base font-semibold text-stone-800 mb-1">{title}</h3>
          <p className="text-sm text-stone-600 leading-relaxed">{description}</p>
        </div>
      </div>
    </div>
  );
}